// Legacy JS module (the verbatim FAQ Q&A content), no types: typed loosely below.
import faqPageContentDefault from 'root/src/client/web/static/FAQ/pageContent';
// The verbatim legacy FAQ content. REUSED as-is (Q&A wording, `<Link>`s and the `{daysToExpire}`
// interpolation are content-significant, see docs/redesign.md "Migrated pages: FAQ"); only the
// presentation is new. Unlike the legal pages this is a plain array, not a `classes` factory, so no
// class map is threaded through it.
export const faqSections = faqPageContentDefault;
